module.exports = __webpack_public_path__ + "img/order-page.f2268198.svg";